<template>
  <div>

    <router-link
      :to="{ name: 'master-product-list' }"
      class="text-decoration-none text-white"
    >
      <b-button
        class="mb-1"
        variant="primary"
      >
        <feather-icon
          icon="ArrowLeftIcon"
          class="mr-75"
        />
        Kembali
      </b-button>
    </router-link>
    <b-card>
      <!-- required required Wajib diisi -->
      <!-- min:x min:3 Minimal x karakter -->
      <!-- max:x max:10 Maksimal x karakter -->
      <!-- email email Format email valid -->
      <!-- numeric numeric Hanya angka -->
      <!-- between:x,y between:1,10 Antara nilai x dan y -->
      <!-- confirmed confirmed:password Cocok dengan field lain -->
      <validation-observer ref="simpleRules">
        <b-form>
          <b-row>
            <!-- Nama Produk -->
            <b-col cols="12">
              <b-form-group
                label="Nama Produk"
                label-for="name"
                label-cols-md="4"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Nama Produk"
                  rules="required"
                >
                  <b-form-input
                    id="name"
                    v-model="name"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Masukkan Nama Produk"
                    @input="generateSKU"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider></b-form-group>
            </b-col>

            <!-- Kode SKU -->
            <b-col cols="12">
              <b-form-group
                label="Kode SKU"
                label-for="sku"
                label-cols-md="4"
              >
                <b-form-input
                  id="sku"
                  v-model="sku"
                  readonly
                />
              </b-form-group>
            </b-col>

            <!-- Kategori -->
            <b-col cols="12">
              <validation-provider
                #default="{ errors }"
                name="Kategori"
                rules="required"
              >
                <b-form-group
                  label="Kategori"
                  label-for="category_id"
                  label-cols-md="4"
                >
                  <v-select
                    id="category_id"
                    v-model="category_id"
                    :options="categoriesOpt"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :state="errors.length > 0 ? false:null"
                    label="title"
                    placeholder="Pilih Kategori"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- Unit -->
            <b-col cols="12">
              <validation-provider
                #default="{ errors }"
                name="Satuan"
                rules="required"
              >
                <b-form-group
                  label="Satuan"
                  label-for="unit_id"
                  label-cols-md="4"
                >
                  <v-select
                    id="unit_id"
                    v-model="unit_id"
                    :options="unitsOpt"
                    placeholder="Pilih Satuan"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :state="errors.length > 0 ? false:null"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col
              cols="12"
            >
              <b-form-group
                label="Harga Beli"
                label-for="cost_price"
                label-cols-md="4"
              >
                <cleave
                  id="number"
                  v-model="cost_price"
                  class="form-control"
                  placeholder="Masukan Harga Beli"
                  :raw="true"
                  :options="currencyOptions"
                />
              </b-form-group>
            </b-col>

            <!-- Gunakan Stok -->
            <b-col cols="12">
              <b-form-group
                label=""
                label-for="is_stock"
                label-cols-md="4"
              >
                <b-form-checkbox
                  v-model="is_stock"
                  value="1"
                  class="custom-control-info"
                > Gunakan Stok </b-form-checkbox>
              </b-form-group>
            </b-col>

            <!-- Gunakan Dimensi -->
            <b-col cols="12">
              <b-form-group
                label=""
                label-for="is_dimension"
                label-cols-md="4"
              >
                <b-form-checkbox
                  v-model="is_dimension"
                  value="1"
                  class="custom-control-info"
                > Barang Dimensi </b-form-checkbox>
              </b-form-group>
            </b-col>

            <!-- editable price -->
            <b-col cols="12">
              <b-form-group
                label=""
                label-for=""
                label-cols-md="4"
              >
                <b-form-checkbox
                  v-model="editable_price"
                  value="1"
                  class="custom-control-info"
                > Edit Harga </b-form-checkbox>
              </b-form-group>
            </b-col>

            <!-- Status -->
            <b-col cols="12">
              <validation-provider
                #default="{ errors }"
                name="Status"
                rules="required"
              >
                <b-form-group
                  label="Status"
                  label-for="status"
                  label-cols-md="4"
                >
                  <v-select
                    id="status"
                    v-model="status"
                    :options="statusOpt"
                    placeholder="Pilih Status"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :state="errors.length > 0 ? false:null"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- Tombol Aksi -->
            <b-col
              md="8"
              offset-md="4"
            >
              <b-button
                type="submit"
                variant="success"
                class="mr-1"
                @click.prevent="validationForm"
              >
                Simpan
              </b-button>
              <b-button
                type="reset"
                variant="outline-secondary"
              >
                Reset
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer></b-card>

    <!-- Harga Repeater Form -->
    <b-card>
      <b-tabs
        pills
        card
      >
        <b-tab
          title="Harga Umum"
          active
        >
          <div>
            <div>
              <b-form
                ref="form"
                :style="{height: trHeight}"
                class="repeater-form"
                @submit.prevent="repeateAgain"
              >

                <!-- Row Loop -->
                <b-row
                  v-for="(item, index) in prices"
                  :id="item.id"
                  :key="item.id"
                  ref="row"
                >

                  <!-- Price -->
                  <b-col md="2">
                    <b-form-group
                      label="Harga Produk"
                      label-for="prices-price"
                    >
                      <cleave
                        id="prices-price"
                        v-model="prices[index].price"
                        :raw="true"
                        class="form-control"
                        type="text"
                        placeholder="Masukkan Harga Jual"
                        :options="currencyOptions"
                      />
                    </b-form-group>
                  </b-col>

                  <!-- Min Sales -->
                  <b-col md="2">
                    <b-form-group
                      label="Minimal Penjualan"
                      label-for="prices-min_sales"
                    >
                      <b-form-input
                        id="prices-min_sales"
                        v-model="prices[index].min_sales"
                        type="number"
                        value="1"
                      />
                    </b-form-group>
                  </b-col>

                  <!-- Remove Button -->
                  <b-col
                    lg="2"
                    md="3"
                    class="mb-50"
                  >
                    <b-button
                      v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                      variant="outline-danger"
                      class="mt-0 mt-md-2"
                      @click="removeItem(index)"
                    >
                      <feather-icon
                        icon="XIcon"
                        class="mr-25"
                      />
                      <span>Delete</span>
                    </b-button>
                  </b-col>
                  <b-col cols="12">
                    <hr>
                  </b-col>
                </b-row>

              </b-form>
            </div>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              @click="repeateAgain"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>Tambah Harga</span>
            </b-button>
          </div>
        </b-tab>
        <b-tab title="Harga Member">
          <div>
            <div>
              <b-form
                ref="memberForm"
                :style="{height: trHeightMember}"
                class="repeater-form"
                @submit.prevent="repeateAgainMember"
              >

                <!-- Row Loop -->
                <b-row
                  v-for="(item, index) in prices_member"
                  :id="'m-'+item.id"
                  :key="'m-'+item.id"
                  ref="memberRow"
                >

                  <!-- Price -->
                  <b-col md="2">
                    <b-form-group
                      label="Harga Produk"
                      label-for="prices-price-member"
                    >
                      <cleave
                        id="prices-price-member"
                        v-model="prices_member[index].price"
                        :raw="true"
                        class="form-control"
                        type="text"
                        placeholder="Masukkan Harga Jual"
                        :options="currencyOptions"
                      />
                    </b-form-group>
                  </b-col>

                  <!-- Min Sales -->
                  <b-col md="2">
                    <b-form-group
                      label="Minimal Penjualan"
                      label-for="prices-min_sales-member"
                    >
                      <b-form-input
                        id="prices-min_sales-member"
                        v-model="prices_member[index].min_sales"
                        type="number"
                        value="1"
                      />
                    </b-form-group>
                  </b-col>

                  <!-- Remove Button -->
                  <b-col
                    lg="2"
                    md="3"
                    class="mb-50"
                  >
                    <b-button
                      v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                      variant="outline-danger"
                      class="mt-0 mt-md-2"
                      @click="removeItemMember(index)"
                    >
                      <feather-icon
                        icon="XIcon"
                        class="mr-25"
                      />
                      <span>Delete</span>
                    </b-button>
                  </b-col>
                  <b-col cols="12">
                    <hr>
                  </b-col>
                </b-row>

              </b-form>
            </div>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              @click="repeateAgainMember"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>Tambah Harga</span>
            </b-button>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BFormInput, BFormGroup, BRow, BCol, BButton, BCard, BForm, BFormCheckbox, BTab, BTabs,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { heightTransition } from '@core/mixins/ui/transition'
// eslint-disable-next-line import/no-cycle
import { formatAccounting } from '@core/utils/utils'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { required } from '@validations'
import Cleave from 'vue-cleave-component'

export default {
  components: {
    ValidationProvider,
    Cleave,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BRow,
    BForm,
    BCol,
    BTab,
    BTabs,
    BButton,
    BCard,
    BFormCheckbox,
    vSelect,

  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      currencyOptions: this.$currencyOptions.number,
      name: '',
      sku: '',
      category_id: null,
      unit_id: null,
      cost_price: 0,
      is_stock: 0,
      is_dimension: 0,
      editable_price: 0,
      prices: [],
      prices_member: [],
      nextTodoId: 2,
      nextTodoIdMember: 2,
      prices_mask: [],
      status: null,
      unitsOpt: [],
      statusOpt: [
        {
          value: 1,
          label: 'Aktif',
        }, {
          value: 0,
          label: 'Tidak Aktif',
        },
      ],
      categoriesOpt: [],
      stockOpt: [
        {
          value: 0,
          label: 'Tidak Stok',
        },
        {
          value: 1,
          label: 'Ya',
        },
      ],
      required,
    }
  },
  computed: {},
  created() {
    this.$http.get('/category')
      .then(res => {
        this.categoriesOpt = res.data.category.map(category => ({
          value: category.id,
          title: category.name,
        }))
      })

    this.$http.get('/unit')
      .then(res => {
        this.unitsOpt = res.data.unit.map(unit => ({
          value: unit.id,
          label: unit.name,
        }))
      })

    this.$http.get(`/product/${this.$route.params.id}`)
      .then(res => {
        const product = res.data

        this.name = product.name
        this.sku = product.sku
        this.category_id = {
          value: product.category_id,
          title: product.category.name,
        }
        this.unit_id = {
          value: product.unit_id,
          label: product.unit.name,
        }
        this.editable_price = product.editable_price
        this.cost_price = Math.round(product.cost_price)
        this.is_stock = product.is_stock
        this.is_dimension = product.is_dimension
        this.status = {
          value: product.status,
          label: product.status === 1 ? 'Aktif' : 'Tidak Aktif',
        }

        this.prices = product.prices.map(price => {
          if (price.member_status === 0) {
            this.$nextTick(() => {
              this.trAddHeight(this.$refs.row[0].offsetHeight)
            })
            return {
              price: price.price,
              min_sales: price.min_sales,
            }
          }
          return null // Explicitly return null for cases where member_status is not 1
        }).filter(item => item !== null) // Filter out null values

        this.prices_member = product.prices.map(price => {
          if (price.member_status === 1) {
            this.$nextTick(() => {
              this.trAddHeightMember(this.$refs.memberRow[0].offsetHeight)
            })
            return {
              price: price.price,
              min_sales: price.min_sales,
            }
          }
          return null // Explicitly return null for cases where member_status is not 1
        }).filter(item => item !== null) // Filter out null values
      })

    window.addEventListener('resize', this.initTrHeight)
  },
  mounted() {
    this.initTrHeight()
  },
  methods: {
    submitProduct() {
      const payload = {
        name: this.name,
        sku: this.sku,
        category_id: this.category_id.value,
        unit_id: this.unit_id.value,
        editable_price: this.editable_price,
        cost_price: this.cost_price,
        is_stock: this.is_stock,
        is_dimension: this.is_dimension,
        price: this.prices,
        price_member: this.prices_member,
        status: this.status.value,
      }

      this.$http.put(`/product/update/${this.$route.params.id}`, payload)
        .then(() => {
          this.$bvToast.toast('Produk berhasil ditambahkan!', {
            title: 'Sukses',
            variant: 'success',
            solid: true,
          })
          // Reset redirect
          this.$router.push({ name: 'master-product-list' })
        })
        .catch(err => {
          console.error(err)
          this.$bvToast.toast('Gagal menambahkan produk.', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
        })
    },
    generateSKU() {
      if (!this.name || this.name.length === 0) {
        this.sku = ''
        return
      }

      // 3 huruf pertama dari nama tanpa spasi
      const base = this.name.replace(/\s+/g, '').substring(0, 3).toUpperCase()

      const randomNum = Math.floor(100 + Math.random() * 900)

      // Cari angka pertama dari string
      const numberMatch = this.name.match(/\d{1,5}/)

      let digits
      if (numberMatch) {
        // Ambil angkanya dan pastikan 3 digit dengan padding 0 di depan
        digits = numberMatch[0].padStart(3, '0')
      } else {
        // Kalau gak ada angka, pakai angka random
        digits = randomNum.toString()
      }

      // Tanggal hari ini (dua digit)
      const date = new Date()
      const day = date.getDate().toString().padStart(2, '0')

      this.sku = `${base}${digits}-${day}`
    },
    formatAccounting,
    // eslint-disable-next-line consistent-return
    isNumber(evt) {
      // eslint-disable-next-line no-param-reassign
      evt = (evt) || window.event
      const charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    repeateAgain() {
      this.prices.push({
        id: this.nextTodoId += this.nextTodoId,
        member_status: null,
        price: 0,
        min_sales: 1,
      })

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
      })
    },
    repeateAgainMember() {
      this.prices_member.push({
        id: this.nextTodoIdMember += this.nextTodoIdMember,
        member_status: null,
        price: 0,
        min_sales: 1,
      })

      this.$nextTick(() => {
        this.trAddHeightMember(this.$refs.memberRow[0].offsetHeight)
      })
    },
    removeItem(index) {
      this.prices.splice(index, 1)
      this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    removeItemMember(index) {
      this.prices_member.splice(index, 1)
      this.trTrimHeightMember(this.$refs.memberRow[0].offsetHeight)
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight)
      })
    },
    initTrHeightMember() {
      this.trSetHeightMember(null)
      this.$nextTick(() => {
        this.trSetHeightMember(this.$refs.memberForm.scrollHeight)
      })
    },
    validationForm() {
      let error = false
      if (this.prices.length > 0) {
        this.prices.forEach((item, index) => {
          if (item.price === 0) {
            this.$bvToast.toast(`Lengkapi data harga row ke ${index + 1} harga produk!`, {
              title: 'Error',
              variant: 'danger',
              solid: true,
            })
            error = true
          }
        })
      } else {
        this.$bvToast.toast('Minimal 1 harga produk!', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
        error = true
      }

      if (!error) {
        this.$refs.simpleRules.validate().then(success => {
          if (success) {
            this.submitProduct()
          } else {
            this.$bvToast.toast('Lengkapi Data Sebelum Submit!', {
              title: 'Error',
              variant: 'danger',
              solid: true,
            })
          }
        })
      }
    },
  },
}
</script>
